import { useSelector } from 'react-redux';
import { selectUser, selectUserRole } from '../../store/slices/userSlice';
import { Insight } from '../../pages/insights/types';
import { UserRole } from '../../store/types';

export default function useCanEditInsight(insight?: Insight) {
  const { userId } = useSelector(selectUser);
  const userRole = useSelector(selectUserRole);

  if (!insight) {
    return false;
  }

  return (
    userId === insight.creatorId ||
    ((userRole as UserRole).edit_insights &&
      insight.creatorId !== import.meta.env.VITE_HOPTHRU_ADMIN_USER_ID)
  );
}
